// Grouped options for the salary sacrifice tax band multiselect
export const salsacTaxBandOptions = [
    {
        group: 'Tax Rates',
        options: [20, 40, 45]
    },
    {
        group: 'Scottish Tax Rates',
        options: [19, 21, 42, 48]
    }
];
